function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongWavyLine = function SvgLongWavyLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1159,
    height: 514,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 7,
    d: "M3 513.462c37.226-45.211 143.166-118.858 269.123-51.768 157.447 83.863 194.062-221.564 293.839-164.62s169.346-186.363 323.131-93.181C1012.12 278.438 1120.38 100.358 1159.13 2",
    style: {
      stroke: "#fff",
      strokeOpacity: 1
    }
  }));
};
export { SvgLongWavyLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE1OSIgaGVpZ2h0PSI1MTQiIHZpZXdCb3g9IjAgMCAxMTU5IDUxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgNTEzLjQ2MkM0MC4yMjU3IDQ2OC4yNTEgMTQ2LjE2NiAzOTQuNjA0IDI3Mi4xMjMgNDYxLjY5NEM0MjkuNTcgNTQ1LjU1NyA0NjYuMTg1IDI0MC4xMyA1NjUuOTYyIDI5Ny4wNzRDNjY1LjczOSAzNTQuMDE4IDczNS4zMDggMTEwLjcxMSA4ODkuMDkzIDIwMy44OTNDMTAxMi4xMiAyNzguNDM4IDExMjAuMzggMTAwLjM1OCAxMTU5LjEzIDIiIHN0cm9rZT0id2hpdGUiIHN0eWxlPSJzdHJva2U6d2hpdGU7c3Ryb2tlLW9wYWNpdHk6MTsiIHN0cm9rZS13aWR0aD0iNyIvPgo8L3N2Zz4K";